import React, {useEffect} from 'react'
// import {useDispatch, useSelector} from 'react-redux'
// import {RootState} from 'store'
import styled, {css} from 'styled-components'
import Logo from '../../assets/images/Logo_Gold.png'
import Breakpoint from '../../utils/breakpoint'
import Font from '../../utils/Font'

const {mobile, desk} = Breakpoint

const Container = styled.div`
  width: 100%;
  min-height: 230px;
  background-color: #f8f0de;
  position: absolute;
  bottom: -115px;
  left: 50%;
  transform: translate(-50%, 0);
  display: flex;
  align-items: center;
  justify-content: center;
  @media (max-width: ${mobile}px) {
    width: 100%;
    position: relative;
    display: block;
    padding-left: 30px;
    padding-right: 30px;
    z-index: 1;
    bottom: -20px;
  }
  @media (min-width: 922px) {
    width: 922px;
  }
`

const Figure = styled.figure`
  flex: 0 1 130px;
  @media (min-width: ${desk}px) {
    margin-right: 45px;
  }
  @media (max-width: ${mobile}px) {
    flex: 0 1 100%;
    padding: 12vw 26vw 8vw;
  }
  & img {
    width: 100%;
    display: block;
  }
`
interface IntroductionProps {
  readonly langCode: string
}
const Introduction = styled.div<IntroductionProps>`
  font-family: ${({langCode}) => Font(langCode).bodyFont};
  flex: 0 1 60%;
  ${({langCode}) =>
    langCode === 'il' &&
    css`
      padding-right: 15px;
    `}
  @media (max-width: ${mobile}px) {
    padding-bottom: 50px;
  }
`

interface IProps {
  miscData: any
  langCode: string
}
const CreatedBlock: React.FC<IProps> = ({miscData, langCode}) => {
  // const content = useSelector((state: RootState) => state.main.contentData)
  // const loading = useSelector((state: RootState) => state.main.loading)
  // const error = useSelector((state: RootState) => state.main.error)
  // const dispatch = useDispatch()

  // useEffect(() => {}, [])

  return (
    <Container>
      <Figure>
        <img src={Logo} alt="Shen Yun" />
      </Figure>
      <Introduction className="Paragraph" langCode={langCode} dangerouslySetInnerHTML={{__html: miscData['createdBlock']}} />
    </Container>
  )
}

export default CreatedBlock
